import { FileStatus } from "@jsq/ds/core";
import { DocumentType } from "../../../lib/graphql/supergraph.index";
import { BaseDocumentType } from "../../../lib/graphql/supergraphOperations";
import { DocumentFormProps } from "../documents/DocumentCollector/types";
import { getDocumentCategoryInfo } from "../documents/DocumentCollector/utils";

export const getExistingProfileDocumentsOrDefault = (
  docTypes: BaseDocumentType[],
  profileId: number,
  documents: Array<DocumentType>,
): DocumentFormProps[] => {
  // Get all matching documents for any of the docTypes
  const matches = documents.filter(
    (doc) =>
      doc.profileId === profileId &&
      docTypes.includes(doc.documentPurpose?.baseType as BaseDocumentType),
  );

  // Group documents by baseType to handle multiple documents per type
  const documentsByBaseType = new Map<BaseDocumentType, DocumentType[]>();

  matches.forEach((doc) => {
    const baseType = doc.documentPurpose?.baseType as BaseDocumentType;
    if (!documentsByBaseType.has(baseType)) {
      documentsByBaseType.set(baseType, []);
    }
    documentsByBaseType.get(baseType)!.push(doc);
  });

  // Always return entries for all expected docTypes
  return docTypes.map((docType) => {
    const documentCategory = getDocumentCategoryInfo(docType);
    const docsForType = documentsByBaseType.get(docType);

    if (docsForType && docsForType.length > 0) {
      // Expected: one document per base type per profile
      // The grouping logic above handles edge cases where multiple documents might exist
      const selectedDoc = docsForType[0];

      return {
        baseType: docType,
        subType: null,
        file: {
          status: "accepted" as FileStatus,
          file: new File([], selectedDoc.name),
          uuid: `${selectedDoc.id}`,
          url: selectedDoc.s3Link,
        },
        title: documentCategory.title,
        description: documentCategory.description,
      };
    } else {
      // Return default entry for missing document
      return {
        baseType: docType,
        subType: null,
        file: null,
        title: documentCategory.title,
        description: documentCategory.description,
      };
    }
  });
};
